import { Cursor } from "@mcleod/components";
import { AssignedMovementOverview } from "./AssignedMovementOverview";
import { ElectronicAdvances } from "./ElectronicAdvances";
import { WireUtil } from "./WireUtil";

export interface ElectronicAdvancesSlideoutProps {
    payeeId: string,
    payeeName: string;
}

export class PayAdvance {

    public static async validateMovement(movementOverview: AssignedMovementOverview) {
        movementOverview.buttonClassicAdvances.visible = false;
        const movementId = movementOverview.sourceMovement.activeRow?.get("id");
        const orderId = movementOverview.sourceMovement.activeRow?.get("orders.id");
        const buttonClassicAdvances = movementOverview.buttonClassicAdvances;

        if (WireUtil.isUserDeniedAccessToLayout()) {
            buttonClassicAdvances.visible = true;
            WireUtil.disableAdvanceButton(buttonClassicAdvances, WireUtil.showDeniedMessage(true));
            return;
        }

        const response = await WireUtil.userPermissionForWireCode();
        const enabledDriverAdvances = response?.enabled_driver_advances;
        const visibleDriverAdvances = response?.visible_driver_advances;
        buttonClassicAdvances.cursor = enabledDriverAdvances ? Cursor.POINTER : null;

        const tooltipMessage = response?.tooltip_message;
        buttonClassicAdvances.visible = visibleDriverAdvances;
        buttonClassicAdvances.enabled = enabledDriverAdvances;
        buttonClassicAdvances.tooltip = tooltipMessage;

        if (buttonClassicAdvances.enabled) {
            buttonClassicAdvances.addClickListener(() => {
                const callBackFunction = () => movementOverview.setCarrierRateData();
                const options = {
                    movementId,
                    movementBrokerage: true,
                    orderId,
                    driverId: null,
                    driverName: null,
                    validatedFrom: "Brokerage",
                    moveType: null,
                    issueAdvanceCallback: callBackFunction
                };
                ElectronicAdvances.showSlider(options);
            });
        }
    }
}
